module.exports = __webpack_public_path__ + "static/media/androidapp.165a5c39.jpg";